import { actions } from './actions'

const initialState = {
  ivas: {
    data: [],
    loading: false,
    error: '',
  },
  ivaDescripciones: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function ivaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.IVAS_LOAD_REQUESTED:
      return { ...state, ivas: { ...state.ivas, loading: true } }
    case actions.IVAS_LOAD_SUCCEEDED:
      return { ...state, ivas: { ...state.ivas, data: action.payload, loading: false } }
    case actions.IVAS_LOAD_FILED:
      return { ...state, ivas: { ...state.ivas, loading: false, error: action.error } }
    case actions.IVAS_DESCRIPCION_LOAD_REQUESTED:
      return { ...state, ivaDescripciones: { ...state.ivaDescripciones, loading: true } }
    case actions.IVAS_DESCRIPCION_LOAD_SUCCEEDED:
      return {
        ...state,
        ivaDescripciones: { ...state.ivaDescripciones, data: action.payload, loading: false },
      }
    case actions.IVAS_DESCRIPCION_LOAD_FILED:
      return {
        ...state,
        ivaDescripciones: { ...state.ivaDescripciones, loading: false, error: action.error },
      }
    case actions.IVA_DESCRIPCION_UPDATE_REQUESTED:
      return {
        ...state,
        ivaDescripciones: { ...state.ivaDescripciones, loading: true, error: '' },
      }
    case actions.IVA_DESCRIPCION_UPDATE_SUCCEEDED:
      return {
        ...state,
        ivaDescripciones: {
          ...state.ivaDescripciones,
          data: state.ivaDescripciones.data.map(estado =>
            estado.id === action.payload.id ? action.payload : estado,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.IVA_DESCRIPCION_UPDATE_FAILED:
      return {
        ...state,
        ivaDescripciones: { ...state.ivaDescripciones, loading: false, error: action.error },
      }
    case actions.IVA_DESCRIPCION_INSERT_REQUESTED:
      return {
        ...state,
        ivaDescripciones: { ...state.ivaDescripciones, loading: true, error: '' },
      }
    case actions.IVA_DESCRIPCION_INSERT_SUCCEEDED:
      return {
        ...state,
        ivaDescripciones: {
          ...state.ivaDescripciones,
          data: [].concat(action.payload, state.ivaDescripciones.data),
          loading: false,
          error: '',
        },
      }
    case actions.IVA_DESCRIPCION_INSERT_FAILED:
      return {
        ...state,
        ivaDescripciones: { ...state.ivaDescripciones, loading: false, error: action.error },
      }
    case actions.IVA_DESCRIPCION_DELETE_REQUESTED:
      return {
        ...state,
        ivaDescripciones: { ...state.ivaDescripciones, loading: true, error: '' },
      }
    case actions.IVA_DESCRIPCION_DELETE_SUCCEEDED:
      return {
        ...state,
        ivaDescripciones: {
          ...state.ivaDescripciones,
          data: state.ivaDescripciones.data.filter(estado => estado.id !== action.id),
          loading: false,
          error: '',
        },
      }
    case actions.IVA_DESCRIPCION_DELETE_FAILED:
      return {
        ...state,
        ivaDescripciones: { ...state.ivaDescripciones, loading: false, error: action.error },
      }
    default:
      return state
  }
}
